import React from 'react'
import { observer } from 'mobx-react-lite'

import Card from '@mui/material/Card'
import Stack from '@mui/material/Stack'

import { Cancel, CheckCircle } from '@mxenabled/mx-icons'
import { H3, P } from '@mxenabled/mxui'

import { Loader, useFinstrongStore, useGlobalCopyStore } from '../../../common'
import { DATE_FORMATS_INTL, formatDate } from '../../../core/constants'

import Transactions from '../shared/Transactions'

const PayBillsOnTimeDrawerComponent = () => {
  const [isLoading, setIsLoading] = React.useState(true)

  const {
    finstrong: {
      key_indicators_spend: { pay_bills_on_time_drawer: copy },
    },
  } = useGlobalCopyStore()

  const { getSpendingFeeTransactions, allTransactions } = useFinstrongStore()

  React.useEffect(() => {
    getSpendingFeeTransactions().finally(() => setIsLoading(false))
  }, [])

  if (isLoading) {
    return <Loader />
  }

  return (
    <>
      {allTransactions.spendingFee.length === 0 ? (
        <Card
          sx={{
            backgroundColor: 'background.paper',
            pb: 48,
            pt: 32,
            px: 24,
            textAlign: 'center',
            width: '100%',
          }}
        >
          <CheckCircle filled={true} size={48} sx={{ color: 'success.main' }} />

          <Stack sx={{ alignItems: 'center', gap: 4, pt: 24 }}>
            <H3>{copy.pay_bills_on_time_zero_fees_title}</H3>
            <P variant="subtitle1">{copy.pay_bills_on_time_zero_fees_description}</P>
          </Stack>
        </Card>
      ) : (
        <Card
          sx={{
            p: 16,
            width: '100%',
            backgroundColor: 'background.paper',
          }}
        >
          <H3 sx={{ textAlign: 'left', pb: 16 }}>{copy.pay_bills_on_time_sticky_fee_count}</H3>
          <Transactions
            amountColor="text.primary"
            amountPosition="flex-start"
            formatDate={(txnDate) =>
              formatDate(new Date(txnDate * 1000), DATE_FORMATS_INTL.MONTH_DAY)
            }
            secondaryIcon={<Cancel color="error" filled={true} size={12} />}
            transactions={allTransactions.spendingFee}
          />
        </Card>
      )}
    </>
  )
}
export default observer(PayBillsOnTimeDrawerComponent)
